// filepath: e:\BLOG\blog-app\frontend\src\api\admin.js
import axios from 'axios';

export const createAdmin = async (data, token) => {
  return axios.post('/api/admin/create-admin', data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const assignRole = async (userId, data, token) => {
  return axios.put(`/api/admin/assign-role/${userId}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getAllUsers = async (token) => {
  return axios.get('/api/admin/users', {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getMe = async (token) => {
  return axios.get('/api/admin/users/me', {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const createWebsite = async (data, token) => {
  return axios.post('/api/websites', data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getWebsites = async (token) => {
  return axios.get('/api/websites', {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const deleteUser = async (userId, token) => {
  return axios.delete(`/api/admin/user/${userId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const updateUser = async (userId, data, token) => {
  return axios.put(`/api/admin/user/${userId}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const removeWebsiteFromUser = async (userId, websiteId, token) => {
  return axios.put(`/api/admin/remove-website/${userId}/${websiteId}`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const deleteWebsite = async (websiteId, token) => {
  return axios.delete(`/api/admin/website/${websiteId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};